/**
 * @file supabase.js
 * @description Initializes and exports the shared Supabase client instance.
 *   Validates required environment variables at startup and throws a clear error
 *   if they are missing, preventing silent auth failures.
 * @author Victor Carpinelli
 * @version 1.0.0
 * @module lib/supabase
 */
import { createClient } from "@supabase/supabase-js";

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL?.trim();
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY?.trim();

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    [
      "[supabase] Missing required environment variables.",
      "Expected:",
      "- REACT_APP_SUPABASE_URL",
      "- REACT_APP_SUPABASE_ANON_KEY",
      "Refusing to initialize Supabase with placeholder credentials.",
      "Add the missing values to your environment before starting the app.",
    ].join("\n")
  );
}

// Capture BEFORE createClient() processes and clears the URL hash/params
const _hash  = new URLSearchParams(window.location.hash.replace(/^#/, ""));
const _query = new URLSearchParams(window.location.search);
export const isRecoveryFlow =
  _hash.get("type") === "recovery" || _query.get("type") === "recovery";

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
export { supabaseUrl };
